"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceBillingDtoToJSON = exports.InsuranceBillingDtoFromJSONTyped = exports.InsuranceBillingDtoFromJSON = exports.instanceOfInsuranceBillingDto = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the InsuranceBillingDto interface.
 */
function instanceOfInsuranceBillingDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfInsuranceBillingDto = instanceOfInsuranceBillingDto;
function InsuranceBillingDtoFromJSON(json) {
    return InsuranceBillingDtoFromJSONTyped(json, false);
}
exports.InsuranceBillingDtoFromJSON = InsuranceBillingDtoFromJSON;
function InsuranceBillingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'comments': !(0, runtime_1.exists)(json, 'comments') ? undefined : json['comments'],
        'holderDob': !(0, runtime_1.exists)(json, 'holder_dob') ? undefined : json['holder_dob'],
        'holderFirstName': !(0, runtime_1.exists)(json, 'holder_first_name') ? undefined : json['holder_first_name'],
        'holderGroup': !(0, runtime_1.exists)(json, 'holder_group') ? undefined : json['holder_group'],
        'holderInsuranceCompanyName': !(0, runtime_1.exists)(json, 'holder_insurance_company_name') ? undefined : json['holder_insurance_company_name'],
        'holderInsuranceIndication': !(0, runtime_1.exists)(json, 'holder_insurance_indication') ? undefined : json['holder_insurance_indication'],
        'holderLastName': !(0, runtime_1.exists)(json, 'holder_last_name') ? undefined : json['holder_last_name'],
        'holderPatientId': !(0, runtime_1.exists)(json, 'holder_patient_id') ? undefined : json['holder_patient_id'],
        'holderFamilyMemberNumber': !(0, runtime_1.exists)(json, 'holder_family_member_number') ? undefined : json['holder_family_member_number'],
        'holderPayorXifinId': !(0, runtime_1.exists)(json, 'holder_payor_xifin_id') ? undefined : json['holder_payor_xifin_id'],
        'holderPlan': !(0, runtime_1.exists)(json, 'holder_plan') ? undefined : json['holder_plan'],
        'holderRelationship': !(0, runtime_1.exists)(json, 'holder_relationship') ? undefined : json['holder_relationship'],
        'insType': !(0, runtime_1.exists)(json, 'ins_type') ? undefined : json['ins_type'],
        'medicareDischargeDate': !(0, runtime_1.exists)(json, 'medicare_discharge_date') ? undefined : json['medicare_discharge_date'],
        'medicareHospitalStatus': !(0, runtime_1.exists)(json, 'medicare_hospital_status') ? undefined : json['medicare_hospital_status'],
        'priorAuthorizationNumber': !(0, runtime_1.exists)(json, 'prior_authorization_number') ? undefined : json['prior_authorization_number'],
    };
}
exports.InsuranceBillingDtoFromJSONTyped = InsuranceBillingDtoFromJSONTyped;
function InsuranceBillingDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'comments': value.comments,
        'holder_dob': value.holderDob,
        'holder_first_name': value.holderFirstName,
        'holder_group': value.holderGroup,
        'holder_insurance_company_name': value.holderInsuranceCompanyName,
        'holder_insurance_indication': value.holderInsuranceIndication,
        'holder_last_name': value.holderLastName,
        'holder_patient_id': value.holderPatientId,
        'holder_family_member_number': value.holderFamilyMemberNumber,
        'holder_payor_xifin_id': value.holderPayorXifinId,
        'holder_plan': value.holderPlan,
        'holder_relationship': value.holderRelationship,
        'ins_type': value.insType,
        'medicare_discharge_date': value.medicareDischargeDate,
        'medicare_hospital_status': value.medicareHospitalStatus,
        'prior_authorization_number': value.priorAuthorizationNumber,
    };
}
exports.InsuranceBillingDtoToJSON = InsuranceBillingDtoToJSON;
